// image for the current page
import Restaurant from "../../../asset/solution/restaurants.webp";
import Hotel from "../../../asset/solution/hotel.webp";
import Business from "../../../asset/solution/BusinessConsultants.webp";
import Nonprofits from "../../../asset/solution/Nonprofits.webp";

//vector
import PDF from "../../../asset/solution/vector/pdf.webp";
import AppStore from "../../../asset/solution/vector/appStore.webp";
import vCard from "../../../asset/solution/vector/vCard.webp";
import Instagram from "../../../asset/solution/vector/Instagram.webp";
import Twitter from "../../../asset/solution/vector/Twitter.webp";
import Spotify from "../../../asset/solution/vector/Spotify.webp";

//active member image
import Contnet from "../../../asset/solution/content.webp";
import Collaborations from "../../../asset/solution/collaborations.webp";
import Files from "../../../asset/solution/files.webp";
import Styles from "../../../asset/solution/styles.webp";
import Support from "../../../asset/solution/support.webp";
import Organized from "../../../asset/solution/organized.webp";

export const qrCodeUses = [
    {
        id: 1,
        title: "For Restaurants",
        heading:
            "QR codes can be an impactful tool for restaurants looking to enhance the dining experience for their customers.",
        image: Restaurant,
        list: [
            `<a href='/qr-code-personal-use'>Personal QR codes</a> can provide diners with a contactless menu they can view on their mobile device, eliminating the need for physical menus and minimizing the risk of spreading germs.`,
            "QR codes can also enable customers to order and pay for their meals from their mobile devices, reducing the need for waitstaff and improving efficiency.",
            "<a href='/qr-code-product-packaging'>QR codes Packaging</a> can track customer purchases and reward loyal customers with discounts or other incentives.",
        ],
    },
    {
        id: 2,
        title: "For Hotels and Resorts",
        heading: `anchorLink`,
        image: Hotel,
        list: [
            "QR codes can enable guests to check in and access their room key directly from their mobile device, reducing the need for physical interaction with the front desk staff.",
            "QR codes enable guests to order room service, request additional amenities, or access other hotel services directly from their mobile devices.",
            "QR codes can inform guests about local attractions, restaurants, and activities, enabling them to plan their itinerary and explore the area more easily.",
        ],
    },
    {
        id: 3,
        title: "For Business Consultants",
        heading:
            "QR codes can be a valuable tool for business consultants looking to streamline their services and improve their marketing efforts.",
        image: Business,
        list: [
            `QR codes can enhance traditional business cards by linking to a consultant's website, <a href="/qr-code-digital-media"> QR Code on social media profiles</a>, and <a href="/qr-code-marketing-card"> QR Codes on Brochures</a>.`,
            `QR codes can provide clients access to whitepapers, case studies, and other thought leadership content to help establish a consultant's expertise.`,
            "QR codes can enable clients to schedule appointments directly from their mobile devices, improving efficiency and minimizing the need for phone calls and emails.",
        ],
    },
    {
        id: 3,
        title: "For Nonprofits",
        heading:
            "QR codes can also be a powerful tool for nonprofits looking to improve their fundraising and engagement efforts.",
        image: Nonprofits,
        list: [
            "QR codes can enable donors to donate directly from their mobile devices, reducing friction and making giving more accessible.",
            "QR codes can link to volunteer sign-up forms or other materials to help recruit new volunteers and supporters.",
            "QR codes can enable attendees to register for fundraising events, galas, and other activities, making tracking attendance and logistics easier.",
        ],
    },
];

export const dynamicQRData = [
    {
        id: 1,
        title: "PDF",
        heading: "Share a downloadable PDF file.",
        image: PDF,
    },
    {
        id: 2,
        title: "App Store",
        heading: "Link your app from multiple stores in one QR Code.",
        image: AppStore,
    },
    {
        id: 3,
        title: "vCard Plus",
        heading: "Display detailed contact info with a save to phone feature.",
        image: vCard,
    },
    {
        id: 4,
        title: "PDF",
        heading: "Share a downloadable PDF file.",
        image: PDF,
    },
    {
        id: 5,
        title: "App Store",
        heading: "Link your app from multiple stores in one QR Code.",
        image: AppStore,
    },
    {
        id: 6,
        title: "vCard Plus",
        heading: "Display detailed contact info with a save to phone feature.",
        image: vCard,
    },
];
export const StaticQRData = [
    {
        id: 1,
        title: "Instagram",
        heading: "Make an Instagram QR Code for Your Content.",
        image: Instagram,
    },
    {
        id: 2,
        title: "Twitter",
        heading: "Post a tweet or share your Twitter profile.",
        image: Twitter,
    },
    {
        id: 3,
        title: "Spotify",
        heading: "Generate a Spotify QR Code for Free.",
        image: Spotify,
    },
    {
        id: 4,
        title: "Instagram",
        heading: "Make an Instagram QR Code for Your Content.",
        image: Instagram,
    },
    {
        id: 5,
        title: "Twitter",
        heading: "Post a tweet or share your Twitter profile.",
        image: Twitter,
    },
    {
        id: 6,
        title: "Spotify",
        heading: "Generate a Spotify QR Code for Free.",
        image: Spotify,
    },
];

export const activeMemberDataleft = [
    {
        id: 1,
        title: "Curated content",
        desc:(
            <>
            As a premium member of Dynamic QR Codes, you can access a curated collection of design templates, layouts, and branding elements to help you create professional-looking <a href='/qr-code-business-card' className="important-link" > Business Card QR Code Generator</a> that match your brand and message.
            </>),
        image: Contnet,
    },
    {
        id: 2,
        title: "Safe Collaborations",
        desc: (
            <>
                As a premium member, you'll also enjoy the benefits of safe collaborations. You can share your 
                <a href='/qr-code-free-with-logo' className="important-link" > free qr code generator with logo </a> 
                with team members or collaborators without worrying about compromising the security of your data or files.
            </>),
        image: Collaborations,
    },
    {
        id: 3,
        title: "High-Quality Files",
        desc:(
            <>
            You can download your codes in a variety of formats, including <a href='/blogs/how-do-i-create-a-high-resolution-qr-code' className="important-link" > QR Code Generator High Resolution</a> images and vector files, making it easy to use your codes in a variety of applications, from social media and websites to print materials and signage.
            </>),
        image: Files,
    },
];
export const activeMemberDataRight = [
    {
        id: 1,
        title: "Edgy Styles",
        desc: "With access to various unique and trendy design templates, you can create codes that are functional, visually appealing, and on-trend. This can help capture your audience's attention and make a lasting impression.",
        image: Styles,
    },
    {
        id: 2,
        title: "Helpful support",
        desc: "Our customer success team is here to help. If not, our help center is open 24/7. We're committed to providing timely and effective support to ensure your satisfaction.  We're always happy to help!",
        image: Support,
    },
    {
        id: 3,
        title: "Seamless Organization",
        desc: "Premium members of Dynamic QR Codes also benefit from seamless organization and management of their codes. With a dedicated dashboard, you can easily create, edit, and track your codes in one place.",
        image: Organized,
    },
];
